import {redeemAccessCode} from 'iq-auth/api';
import type {PostAuthAction} from 'iq-auth/post_auth_actions/types';

/**
 * Redeems an enterprise/cohort access code (`?c=` on signup/login) once the user
 * is authenticated. Enqueued from the signup/login pages when a code is present,
 * then drained by completeAuth — so it works for both password and OAuth, which
 * the backend's own auto-upgrade does not cover for OAuth. Best-effort: an
 * invalid/expired code fails silently rather than blocking account creation.
 */
export const redeemAccessCodeAction: PostAuthAction<{code: string; email?: string}> = {
  key: 'iq:access-code',
  run: async ({code, email}) => {
    await redeemAccessCode(code, email);
  },
};
